import "./App.css";
import React from "react";
import DappPortfolio from "./DappPortfolio";

//import LandingPage from "../src/components/LandingPage";

function App() {
  return <DappPortfolio />;
}

export default App;
